<script>
import Layout from "../../layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from "@/components/Page-header";
import appConfig from "@/../app.config";
import CompanyItemsAPI from "@/services/items/companies_itemsAPI";
import proveedorContratistaAPI from "@/services/standards/crearProveedorContratista/proveedorContratistaAPI";
import CheckModal from "@/components/CheckModal"
import { dateFormat } from "@/utils/helpers/format";
import ItemAPI from "@/services/items/itemsAPI";
import revisionAnualAPI from "../../../services/standards/revisionAnual/revisionAnualAPI";
import proveedoresEvaluacionAPI from "../../../services/standards/proveedoresEvaluacion/proveedoresEvaluacionAPI";
/**
 * Form elements component
 */
export default {
  page: {
    title: "2.10.1 Evaluación y selección de proveedores y contratistas",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    Style,
    PageHeader,
    CheckModal,
  },
  data() {

    return {
      title: "2.10.1 Evaluación y selección de proveedores y contratistas",
      items: [

        {
          text: "Estandares",
          href: "/forms/estandares",
        },
        {
          text: "Evaluación y selección de proveedores",
          href: `/forms/estandares/${
            this.$store.getters["company/getCompany"].id || null
          }/evaluacion-seleccion-proveedores`,
        
        },
        {
          text: "Ver",
          active: true,
        },
      ],

      colaboradorProveedor: [],
      lista: [],
      evaluacion: [],
      file: null,
      loading: true,
      acta: null,

      item: null,
      search: "",

      itemData: null,

      list: [
        {
          id: 1,
          name: "Exámenes de ingreso"
        },
        {
          id: 2,
          name: "Exámenes periódicos"
        },
        {
          id: 3,
          name: "examen de retiro"
        }
      ],

      evaluacionProveedores: {
        providers_contractors_id: null,
        companies_id: this.$store.getters["company/getCompany"].id || null,
        option: null,
        description: null,
        file: null,
        evaluated_last_year: null,
      },

      companyID: this.$store.getters["company/getCompany"].id || null,
      classificationID: this.$store.getters["company/getCompany"].company_classification_id || null,
      user: this.$store.state.auth || null,
    };
  },
  methods: {

    getItemData() {
      ItemAPI.getItems(55)
        .then((response) => {
          this.itemData = response;
          this.loading = false
        })
        .catch((error) => {
          console.log(error);
        });
    },

    allowAccess() {
      try {
        const item = this.itemData;

        if (item) {
          const classificationID =
            this.$store.getters["company/getCompany"].company_classification_id || null;

          if (classificationID === 1 && item.obligatory_UPA === 1) {
            return true;
          } else if (classificationID === 2 && item.obligatory_groupI === 1) {
            return true;
          } else if (classificationID === 3 && item.obligatory_groupII === 1) {
            return true;
          } else if (classificationID === 4 && item.obligatory_groupIII === 1) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } catch (error) {
        console.log(error);
        return false;
      }
    },

    goPage(page) {
      window.location.href = page
    },

    dateConvert(date) {
      return dateFormat(date);
    },

    getItems() {
      CompanyItemsAPI.getStatus(this.companyID, 55)
        .then(response => {
          this.item = response || null
        })
        .catch(error => {
          console.log(error)
        })
    },


    /**
    * This method is used to knows if the user has the permission indicated
    * @param {String} name The name of the permission
    * @param {Array} roles the roles that permitted to access the action 
    * @returns {Boolean} true if the user has the permission indicated or false if no
    */
    getRole(name, roles) {

      // Get the user role
      let role = this.$store.state.auth.info.role ? this.$store.state.auth.info.role : null

      // If the user is logged
      if (role) {

        // If the roles array is not empty
        if (roles) {

          // Know if the role indicated is in the roles array
          role = roles.includes(role) ? true : false

        } // Close if the roles arrays is not empty

        // If the roles arrays is empty
        else {

          // Know if the user role is in the roles indicated
          role = role === 1 || role === 2 || role === 3 || role === 4 || role === 5 || role === 6 || role === 7 || role === 8

        } // Close if the roles arrays is empty

        // Get the user permissions
        const permissions = this.$store.state.auth.info.permissions

        // Know if the user has the permission indicated
        const enabled = permissions.find(permission => permission.name === name)

        // If the user has the permission indicated and the user role is in the roles indicated
        return enabled && role ? true : false

      } // Close if the user is logged

      // If the user is not logged
      else {
        return false
      } // Close else the user is not logged
    },

    /**
   * This method is used to redirect to the page indicated
   * @param {String} page The page to redirect
   */
    goPage(page) {
      window.location.href = page
    },


    getPC() {
      proveedorContratistaAPI.getAll()
        .then((response) => {
          this.loading = false
          let proveedorC = response.data.data;
          this.colaboradorProveedor = proveedorC
        })
        .catch((error) => {
          console.log(error);
          this.loading = false
        });
    },


    getActa() {
      revisionAnualAPI.getActa()
        .then((response) => {
          this.acta = response;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getEvaluacion() {
      proveedoresEvaluacionAPI.getShow(this.$route.params.id)
        .then((response) => {
          let evaluacionP = response
          this.loading = false
          this.evaluacion = evaluacionP
          this.evaluacionProveedores = {
            providers_contractors_id: response.providers_contractors_id,
            option: response.option,
            description: response.description,
            file: response.file,
            evaluated_last_year: response.evaluated_last_year,
          };
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getList() {
      proveedoresEvaluacionAPI.getAll()
        .then((response) => {
          let identificacion = response.data.data;
          this.lista = identificacion
          this.loading = false
        })
        .catch((error) => {
          console.log(error);
        });
    },

    async print() {
      try {
        revisionAnualAPI.getActa()
          .then((response) => {
            this.acta = response;
          })
        const url = this.acta;
        window.location.href = url;
      } catch (error) {
        console.log(error);
      }

    },

    goBack() {
      this.$router.go(-1);
    },

    gotoDigitalOcean(url) {
      window.open(url);
    },

  },

  mounted() {
    this.getActa();
    this.getItems();
    this.getList();
    this.getItemData();
    this.getPC();
    this.getEvaluacion();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-md-12">
        <div class="col-xl-12" v-if="!loading">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-12 text-right m-b-0">
                  <div class="btn btn-secondary m-l-5 ml-1" id="back" @click="goBack">
                    <i class="fas fa-arrow-left"></i>
                  </div>
                  <b-tooltip target="back" placement="left"> Volver </b-tooltip>
                </div>
              </div>

              <form class="form-group" @submit.prevent="save">
                <div class="form-row pt-3">

                  <b-form-group label-for="employee" class="col-md-4 px-2 mb-3" label="Proveedor">
                    <select :disabled="!getRole('Crear') || !allowAccess()" disabled class="form-control"
                      v-model="evaluacionProveedores.providers_contractors_id">
                      <b-form-select-option v-for="item in colaboradorProveedor" :key="item.id" :value="item.id">
                        {{ item.name }} - {{ item.type }}
                      </b-form-select-option>
                    </select>
                  </b-form-group>

                  <b-form-group label-for="employee" class="col-md-4 px-2 mb-3" label="Producto y/o servicio">
                    <select disabled class="form-control" v-model="evaluacionProveedores.option">
                      <b-form-select-option value="Producto">
                        Producto
                      </b-form-select-option>
                      <b-form-select-option value="Servicio">
                        Servicio
                      </b-form-select-option>
                    </select>
                  </b-form-group>

                  <b-form-group label-for="employee" class="col-md-4 px-2 mb-3" label="¿Evaluada el ultimo año?">
                    <select disabled class="form-control" v-model="evaluacionProveedores.evaluated_last_year">
                      <b-form-select-option value="SI">
                        Si
                      </b-form-select-option>
                      <b-form-select-option value="NO">
                        No
                      </b-form-select-option>
                    </select>
                  </b-form-group>

                  <b-form-group class="col-md-12 px-2" label="Descripción del producto o servicio"
                    label-for="trainingDate">
                    <b-form-textarea disabled id="trainingDate" v-model="evaluacionProveedores.description">
                      >
                    </b-form-textarea>

                  </b-form-group>

                  <b-form-group class="col-md-12 px-2" label="Descargar evidencia de selección" label-for="file">
                    <button :disabled="!allowAccess()" style=" background-color: transparent !important; border: none;"
                      type="button" @click="gotoDigitalOcean(`${evaluacionProveedores.file}`)"> <i class="mdi mdi-cloud-download"></i>
                    </button>
                  </b-form-group>
                </div>
              </form>
            </div>
          </div>

        </div>

        <div v-else class="col-xl-12 text-center">
          <div class="text-center">
            <b-spinner variant="primary" label="Loading..."></b-spinner>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
.background-modal {
  background-color: transparent !important;
  border: none;
}
</style>